import { TrajectorySectionType } from './Trajectory';
import { BackendBlock } from './Block';

export type Page = {
  id: string;
  title: string;
  type: TrajectorySectionType;
  blocks: string[];
  hasContent: boolean;
  isPrintable: boolean;
};

// BACKEND

export type BackendPage = Page & {
  blocks: BackendBlock[];
};

// MAPPER

export const mapBackendPageToPage = (data: BackendPage): Page => ({
  id: data.id,
  title: data.title,
  type: data.type,
  blocks: data.blocks,
  hasContent: data.hasContent,
  isPrintable: data.isPrintable,
});

export const getPageMapper = (response: { data: BackendPage }): Page =>
  mapBackendPageToPage(response.data);

export const getPagesMapper = (response: any): Page[] => response.data.map(mapBackendPageToPage);
